export default __webpack_public_path__ + "static/allency-banner-contact-us-1886f8bc08407642c45c0faedc1353e4.png";